import React from "react";
import { Checkbox } from "@irati/ui/src/FormItem";
import Flex from "@irati/ui/src/Flex";
import { FormattedCurrency, FormattedMessage } from "@irati/utils/lang";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import Spacing from "@irati/ui/src/Spacing";
import { Row } from "@irati/ui/src/ColumnRow";
var PROPERTY = "paymentOptions.zip.enable";
var PayByWalletCheckBox = function (props) {
    var value = props.value, onChange = props.onChange, currency = props.currency, availableBalance = props.availableBalance, remainingBalance = props.remainingBalance;
    return (React.createElement(Spacing, { marginBottom: 2 },
        React.createElement(Row, null,
            React.createElement(Checkbox, { name: PROPERTY, id: "platform.wallet.components.payByWallet.checkbox.label", checked: value, onChange: function () { return onChange(!value); } },
                React.createElement(Flex, { inline: true, alignItems: "center", marginTop: true },
                    React.createElement(FormattedMessage, { id: "platform.wallet.components.payByWallet.checkbox.label" }),
                    React.createElement(Icon, { icon: IconTypes.wallet, marginRight: true, marginLeft: true }),
                    React.createElement(FormattedCurrency, { currency: currency, value: availableBalance })))),
        value && (React.createElement(Flex, { marginTop: true },
            React.createElement(FormattedMessage, { id: "platform.wallet.components.payByWallet.remainingBalance", values: { amount: React.createElement(FormattedCurrency, { value: remainingBalance, currency: currency }) } })))));
};
export default PayByWalletCheckBox;
